import { Component, OnInit } from '@angular/core';
import { ServicioService} from 'app/services/servicio.services';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import swal from 'sweetalert2';
import { correctHeight } from 'app/app.helpers';

interface FormModel {
  captcha?: string;
}

@Component({
  selector: 'app-certificados',
  templateUrl: './certificados.component.html',
  styleUrls: ['./certificados.component.css']
})

export class CertificadosComponent implements OnInit {
  
  public formModel: FormModel = {};
  constructor(private formBuilder: FormBuilder, private _servicios: ServicioService, private _router: Router) { }
  public subjet : any;
  public body : any;
  public mail : any;

  cForm = new FormGroup({
    
    body: new FormControl("",Validators.required),
    mail: new FormControl("",Validators.required),
    captcha: new FormControl("",Validators.required)
  });
  ngOnInit() {
    if(sessionStorage.getItem("token")== null){
      this._router.navigateByUrl("login");
    }
  }

  enviarCorreo(){
    let correo = new mail();
    correo.body = this.body;
    correo.mail = this.mail;
    correo.cliente = sessionStorage.getItem("cliente");
    this._servicios.enviarCorreos(correo).subscribe(
      result =>{
        if(result){
          swal(
            'Correo Enviado!',
            '',
            'success'
          )
        }
        console.log("Correo Enviado");
      });
      
  }

}

 class mail{
  mail: any;
  body: any;
  cliente: any;
}



// WEBPACK FOOTER //
// ./src/app/certificados/certificados.component.ts